export class TempleProfile {
    constructor(
        public id?: number,
        public name?: string,
        public mainDeity?: string,
        public organisationId?: number,
        public accountNo?: string,
        public ifscCode?: string,
        public history?: string,
        public templeCode?: string,
        public address1?: string,
        public address2?: string,
        public post?: string,
        public city?: string,
        public district?: string,
        public state?: string,
        public country?: string,
        public pincode?: string,
        public mobile?: string,
        public phone?: string,
        public email?: string,
        public latitude?: string,
        public longitude?: string,
        public rating?: string,

    ) { }
}
